export enum Mode {
    EDIT = 'EDIT',
    PRINT = 'PRINT',
}
